import Keycloak from 'keycloak-js'
import { isNull } from 'lodash'
import { tokenStorage } from '@ublique/synapse/authentication/utils'
import { userStore } from 'services/state'

class UbliqueKeycloak {
  constructor({ url, redirectUri, clientId, realm = 'Ublique' }) {
    this.keycloakInstance = null
    this.url = url
    this.redirectUri = redirectUri
    this.clientId = clientId
    this.realm = realm
  }

  createJSONConfig() {
    return {
      url: this.url,
      realm: this.realm,
      clientId: this.clientId,
      redirectUri: this.redirectUri,
      responseType: 'code',
      scope: 'openid',
      checkLoginIframe: false
    }
  }

  // refactor per semplificare
  initConfiguration() {
    return {
      onLoad: 'login-required',
      checkLoginIframe: false,
      responseMode: 'query',
      redirectUri: this.redirectUri
    }
  }

  actualConfiguration() {
    return {
      onLoad: 'login-required',
      redirectUri: this.redirectUri,
      checkLoginIframe: false,
      responseMode: 'query',
      token: tokenStorage.getToken(),
      refreshToken: tokenStorage.getRefreshToken()
    }
  }

  ubliqueLogin(loginCallback) {
    if (isNull(this.keycloakInstance)) {
      this.sendLoginRequest(loginCallback)
    }
  }

  ubliqueLogout(logoutCallback) {
    if (isNull(this.keycloakInstance)) {
      this.sendLogoutRequest(logoutCallback)
    } else {
      this.logout(this.keycloakInstance, logoutCallback)
    }
  }

  ubliqueUpdatePassword() {
    if (isNull(this.keycloakInstance)) {
      this.sendUpdatePasswordRequest()
    } else {
      this.updatePassword()
    }
  }

  sendLoginRequest(loginCallback) {
    const keycloak = new Keycloak(this.createJSONConfig())
    keycloak.init(this.initConfiguration()).then((authenticated) => {
      loginCallback(keycloak)
      this.keycloakInstance = keycloak
      userStore.set(keycloak.tokenParsed)
    })
  }

  sendLogoutRequest(logoutCallback) {
    const keycloak = new Keycloak(this.createJSONConfig())
    keycloak.init(this.actualConfiguration()).then((authenticated) => {
      this.logout(keycloak, logoutCallback)
    })
  }

  logout(KC, logoutCallback) {
    KC.logout()
    logoutCallback()
  }

  sendUpdatePasswordRequest() {
    const keycloak = new Keycloak(this.createJSONConfig())
    keycloak.init(this.actualConfiguration()).then((authenticated) => {
      this.keycloakInstance = keycloak
      this.updatePassword()
    })
  }

  updatePassword() {
    this.keycloakInstance.login({
      action: 'UPDATE_PASSWORD',
      redirectUri: this.redirectUri
    })
  }
}

export default UbliqueKeycloak
